export const ROVO_SKILL_EXTENSION_TYPE = 'com.atlassian.rovo.skill';
export const ROVO_SKILL_EXTENSION_KEY = 'skill';
export const ROVO_SKILL_QUICK_INSERT_ACTION_KEY = 'skillTag';
export const ROVO_SKILL_TAG_PATTERN: RegExp = /\/([a-zA-Z0-9-]+)/g;
/**
 * Extension key is returned to us from ReactRenderer in a combined format
 */
export const ROVO_SKILL_COMBINED_EXTENSION_KEY: 'skill:skillTag' = `${ROVO_SKILL_EXTENSION_KEY}:${ROVO_SKILL_QUICK_INSERT_ACTION_KEY}`;

export const isSkillTagExtension = (extensionType: string, extensionKey: string): boolean => {
	return (
		extensionType === ROVO_SKILL_EXTENSION_TYPE &&
		extensionKey === ROVO_SKILL_COMBINED_EXTENSION_KEY
	);
};
